import script from "./AfterSubmit.vue?vue&type=script&setup=true&lang=js"
export * from "./AfterSubmit.vue?vue&type=script&setup=true&lang=js"

import "./AfterSubmit.vue?vue&type=style&index=0&id=5faac122&lang=scss&scoped=true"

import exportComponent from "E:\\work\\flaggerforce\\flagger-force-orders-module\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5faac122"]])

export default __exports__